import type { SystemUserFormSchema } from './schemas';

export const defaultValues: Readonly<SystemUserFormSchema> = {
  id: -1,
  name: '',
  first_name: '',
  last_name: '',
  email: '',
  username: '',
  status: { name: '', value: '' },
  user_type: '',
  microsoft_groups: '',
  profile_images: [],
  roles: null,
  team_member: null,
} as const;
